import React from "react";
import { Link } from "react-router-dom";
import { openCalendlyPopup } from "../../util/calendly";
import "./Hero.css";
import arrowRight from "../../images/arrow-right.svg";
import BookDemoHeroTitle from "./BookDemoHeroTitle";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-section-content">
        <Link to="/strategies" className="portfolio-analyzer-link">
          View Strategy Performance{" "}
          <img src={arrowRight} alt="Arrow" className="arrow-icon" />
        </Link>
        <BookDemoHeroTitle />
        <div className="hero-benefits">
          <div className="benefit-item">
            <div className="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
              </svg>
            </div>
            <span><span className="hero-section-highlight">Active Traders</span>: Reduce screen time by 90%</span>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
            <span><span className="hero-section-highlight">Funded Traders</span>: Scale your account faster</span>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 6l-9.5 9.5-5-5L1 18" />
                <path d="M17 6h6v6" />
              </svg>
            </div>
            <span><span className="hero-section-highlight">Passive Investors</span>: Build wealth hands-free</span>
          </div>
        </div>
        <p className="hero-description">
          Join 500+ futures traders who've automated their success. Our proven algorithms 
          trade 24/7, eliminating emotional decisions and maximizing your returns—whether 
          you're actively trading or building passive income.
        </p>
        <div className="hero-cta-container">
          <a
            href="#"
            onClick={openCalendlyPopup}
            className="cta-button hero-section-button"
          >
            Book Your Free Demo
          </a>
          <p className="cta-subtext">No commitment required • 30-minute call</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
